module.exports = __webpack_public_path__ + "img/section2_img3.1828b371.png";